module.exports = __webpack_public_path__ + "static/media/instructions.761870a5.pdf";